import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import {markPackaged} from "../../../services/api/apiNextBarcode"
import Button from "reactstrap/es/Button"
import Promise from 'bluebird'

class BulkMarkPackagedModal extends Component{
    constructor(props) {
        super(props);
        this.state = {
            status: '',
            customerChange: '',
            note: '',
            listItems: [],
            itemsSuccess: [],
            itemError: [],
            itemLoading: '',
            validated: false
        }
    }

    componentDidMount = async () => {
        await this._genListItems()
    }

    _genAllItems = () => {
        const {listItems} = this.state
        const listItemsNotMarkInProduction = listItems.filter(item => item.production_status !== 'packaged')
        this._bukdMarkPackaged(listItemsNotMarkInProduction)
    }

    _genListItems = () => {
        const {items, selectedItems} = this.props
        const listItems = items.filter(item => selectedItems.includes(item._id))

        this.setState({
            listItems
        })
    }

    _bukdMarkPackaged = async (listItems) => {
        const total = this.state.itemsSuccess.length > 0 ? (listItems.length + this.state.itemsSuccess.length) : listItems.length

        await Promise.each(listItems, async item => {
            this.setState({
                itemLoading: item._id
            })

            try {
                const {success, message} = await markPackaged(item.barcodeNumber)
                let {itemError, itemsSuccess} = this.state

                if(success) {

                    itemsSuccess.push(item._id)

                    this.setState({
                        itemsSuccess: itemsSuccess,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })


                } else {
                    itemError.push({
                        _id: item._id,
                        message: message
                    })

                    this.setState({
                        itemError: itemError,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                }
            } catch (e) {
                let {itemError, itemsSuccess} = this.state

                this.setState({
                    itemError: e.message,
                    itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                })
            }

        })
    }

    _markPackagedItem = async (item) => {
        try {
            const {itemsSuccess, itemError} = this.state
            const {success, message} = await markPackaged(item.barcodeNumber)

            if(success) {
                itemsSuccess.push(item._id)

                this.setState({
                    itemsSuccess: itemsSuccess,
                    itemLoading: ''
                })
            } else {
                const newItemErr = itemError.map(item2 => {
                    if(item2._id === item._id) {
                        return {
                            ...item2,
                            message: message
                        }
                    }
                    return item2
                })

                this.setState({
                    itemError: newItemErr,
                    itemLoading: ''
                })
            }
        } catch (e) {
            this.setState({
                itemError: e.message,
                itemLoading: ''
            })
        }
    }

    _handleSubmit = (e) => {
        e.preventDefault()
        
        this.setState({
            validated: true
        })

        const r = window.confirm(`Bạn có chắc chắn muốn mark packaged?`)

        if (r !== true) {
            this.setState({
                validated: false
            })
            return
        }

        this._genAllItems()
    }

    _handleClickRetryItem = async (item) => {
        const {itemError} = this.state
        const newItemsStatus = itemError.map(item2 => {
            if(item2._id === item._id) {
                return {
                    ...item2,
                    message: ''
                }
            } else {
                return item2
            }
        })

        this.setState({
            itemError: newItemsStatus,
            itemLoading: item._id
        })

        this._markPackagedItem(item)
    }

    _retryAll = () => {
        const {itemError} = this.state

        this.setState({
            itemError: []
        })

        this._bukdMarkPackaged(itemError)
    }

    _showMessage = (itemError, itemsSuccess, item) => {
        if(item.production_status === 'packaged'){
            return (
                <span className="d-sm-block text-success">Marked Packaged!</span>
            )
        }else if(itemError.find(itemErr => item._id === itemErr._id) !== undefined) {
            if(itemError.find(itemErr => item._id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => item._id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if(itemsSuccess.includes(item._id)) {
            return (
                <span className="d-sm-block text-success">Mark packaged success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    _genIcon = (item) => {
        const {itemsSuccess, itemError} = this.state

        if(item.production_status === 'packaged') return <i className="icon-check text-success"/>

        if(itemsSuccess.includes(item._id)) return <i className="icon-check text-success"/>

        if(itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) return <i className="icon-cross text-danger"/>

        return <i className="icon-spinner6 text-dark"/>
    }

    render() {
        const {isOpen, handleToggleModal} = this.props
        const {listItems, itemLoading, itemsSuccess, itemError} = this.state
        const listItemsMarkedInProduction = listItems.filter(item => item.production_status === 'packaged')
        const disabledButton = listItemsMarkedInProduction.length === listItems.length || (itemsSuccess.length + listItemsMarkedInProduction.length) === listItems.length ? true : false
        
        return (
            <div>
                <Modal isOpen={isOpen} className="BulkChangeStatus"
                >
                    <ModalHeader>
                        Mark Packaged
                    </ModalHeader>
                    <ModalBody>
                        {listItems.length > 0 && (
                            <div className="ListChangeStatus">
                                {
                                    listItems.map(item => {
                                        return (
                                            <div key={item._id} className="ItemChangeStatus d-sm-flex mb-2 pb-2">
                                                <div className="IconStatus mr-2">
                                                    {this._genIcon(item)}
                                                </div>
                                                <div className="ContentChangeStatus">
                                                    <strong>{item.orderNumber}</strong> - orderID: #{item.barcodeNumber}
                                                    {
                                                        (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemLoading !== item._id) && (
                                                            <span onClick={() => this._handleClickRetryItem(item)}>
                                                            <i className="icon-spinner11 text-danger ml-2"/>
                                                        </span>
                                                        )
                                                    }
                                                    {itemLoading === item._id && <i className='icon-spinner2 spinner ml-2'/>}
                                                    {this._showMessage(itemError, itemsSuccess, item)}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            
                            <Button disabled={itemLoading !== ''} onClick={handleToggleModal} className="bg-grey ml-2">
                                Cancel
                            </Button>
                            {
                            itemError.length > 0 ? <Button disabled={disabledButton} onClick={this._retryAll} className="bg-danger ml-2"><i className="icon-spinner11 mr-1"/>Retry Mark Packaged</Button> : 
                            <Button disabled={disabledButton} onClick={this._handleSubmit} className="bg-primary ml-2">
                                Mark Packaged
                            </Button>
                            }
                            
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default BulkMarkPackagedModal